import { DateTime } from 'luxon';

import { Nullable } from '@clearverify/types';

/**
 * Month pickers return the picked month with the day/time of the previous value (and clamp the day
 * when the new month is shorter), so a range can end mid-month without the user asking for it.
 * The server groups every timestamp by UTC month, so both edges are snapped to the UTC month
 * boundary — `keepLocalTime` keeps the month the user actually clicked if the value is not UTC yet.
 */
const toUtcMonth = (date: Nullable<DateTime>) =>
  date?.isValid ? date.setZone('utc', { keepLocalTime: true }) : date;

export const snapToUtcMonthStart = (date: Nullable<DateTime>) =>
  toUtcMonth(date)?.startOf('month') ?? date;

export const snapToUtcMonthEnd = (date: Nullable<DateTime>) =>
  toUtcMonth(date)?.endOf('month') ?? date;
